import { BoxProps } from '@mui/material';
import { EquipmenId, PriceType } from '../../types/equipment';
import { RootState, useAppSelector } from '../../redux/store';
import { getPriceCatalogKey } from '../../utils/equipment';
import { StyledPriceLabel } from './PriceLabelStyle';
import { isAuthenticated } from '../../utils/authUtils';

interface PriceLabelProps extends BoxProps {
  equipmentId: EquipmenId;
  priceType?: PriceType;
  isLoading: boolean;
  useLightBg?: boolean | undefined;
  rightAlign?: boolean | undefined;
}

function PriceLabel({ equipmentId, priceType, isLoading, useLightBg, rightAlign, ...rest }: PriceLabelProps) {
  const priceEntry = useAppSelector((state: RootState) => state.prices.priceCatalog[getPriceCatalogKey(equipmentId)]);
  const authState = useAppSelector((state: RootState) => state.auth);

  return (
    <>
    { (priceType || priceEntry?.price) && isAuthenticated(authState.loginStatus) && !isLoading ? 
      <StyledPriceLabel className='price-type-label' useLightBg={useLightBg} rightAlign={rightAlign} {...rest}>
        {priceEntry?.companyId || priceType === PriceType.COMPANY ? `YOUR RATE` : `BRANCH RATE`}
      </StyledPriceLabel>
      : <></>
    }
    </>
  );
}

export default PriceLabel;
